<template>
  <div class="orderCenter">
    <div class="orderCenter-top">
      <div class="top-item">我的报名</div>
      <div class="top-navs">
        <div
          v-for="(item, index) in navlist"
          :key="index"
          @click="getdata(item.id)"
          class="navs-item"
          :class="item.id == navsindex ? 'active' : ''"
        >
          <div>
            {{ item.name }}<span v-if="item.num != null">({{ item.num }})</span>
          </div>
          <div
            class="borderBottom"
            :class="item.id == navsindex ? 'active' : ''"
          ></div>
        </div>
      </div>
    </div>
    <div class="orderCenter-bottom">
      <div
        class="bottom-item"
        v-for="(item, index) in datalist"
        :key="index"
        :class="index != 0 ? 'active' : ''"
      >
        <div style="display: flex; justify-content: space-between">
          <div class="bottom-item-left">
            <div class="bottom-item-left-title1">
              {{ item.tourName }}
            </div>
            <div class="bottom-item-left-title2">
              报名时间：{{ item.appointDate }} {{ item.appointTimeStart }}
            </div>
            <div class="bottom-item-left-title2">姓名：{{ item.name }}</div>
            <div v-if="item.status == 1">待审核</div>
            <div v-if="item.status == 2">已通过</div>
            <div v-if="item.status == 3">已核销</div>
            <div v-if="item.status == 4">已取消</div>
            <div v-if="item.status == 6">未通过</div>
            <div v-if="item.status == 5">已过期</div>
            <div
              class="bottom-item-left-title3"
              @click="
                deleteshow = true;
                deleteid = item.id;
              "
              v-if="item.status == 2 || item.status == 1"
            >
              取消报名
            </div>
          </div>
          <div class="ma" v-if="item.status == 2">
            <img :src="item.qrcode" alt="" @click="myma(item.qrcode)" />
            <div style="font-size: 0.1rem; color: #a78d60">点击查看报名码</div>
          </div>
        </div>

        <div
          v-if="item.status == 6"
          style="font-size: 0.11rem; margin-top: 0.1rem"
        >
          您未通过报名，本场次参观人数已满，请选择其他日期，谢谢！
        </div>
      </div>
      <div v-if="datalist.length == 0" class="nobottom">
        <img src="../assets/appointment.png" alt="" />
      </div>
      <div class="prompt">
        <p>温馨提示：</p>
        <p>
          1、我馆实行实名、全报名制度。有效报名证件为身份证、护照、港澳通行证、台胞证。
        </p>
        <p>
          2、每张有效身份证件每时段仅可报名一次,每个账号每天最多实名报名3人,每人的姓名和有效证件号码均需如实填写(小孩也需报名),信息与本人不符将不能入馆。
        </p>
        <p>3、报名成功后,参观当日凭本人身份证或报名码等有效证件通过信息核验。</p>
        <p>4、如您不能按时到馆,请提前取消报名。连续2次或累计3次(30天之内)报名未到馆,将触发限制报名机制,限制报名机制触发之后30日内将无法进行报名参观 .</p>
        <p style="color: red">5、报名成功后根据报名时间准时前往参观,该场次开始10分钟后,不再安排入馆,谢谢理解和配合!</p>
        <p>6、如有疑问请拨打电话：021-64389338</p>
        <p>7、每周一11:00开放本周二至下周二参观报名（遇节假日相应调整）。</p>
      </div>
    </div>
    <div class="pull" v-if="show" @click="onpull($event)">
      <img :src="myurl" alt="" width="80%" />
    </div>
    <el-dialog
      :visible.sync="deleteshow"
      width="70%"
      :show-close="false"
      :close-on-click-modal="false"
      class="el-dialog-centent"
    >
      <div class="pull-con">
        <div class="pull-con-title1">温馨提示</div>
        <div class="pull-con-title2">确定取消报名吗？</div>
        <div class="pull-button">
          <div
            @click="deleteshow = false"
            style="background-color: rgba(167, 141, 96, 0.3); color: #a78d60"
          >
            取消
          </div>
          <div @click="cancel" style="background-color: #a78d60; color: #fff">
            确定
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      //订单列表状态
      navlist: [
        {
          name: "审核中",
          id: 1,
          num: "",
        },
        {
          name: "已通过",
          id: 2,
          num: "",
        },
        {
          name: "未通过",
          id: 6,
          num: "",
        },
        {
          name: "已核销",
          id: 3,
          num: null,
        },
        {
          name: "已取消",
          id: 4,
          num: null,
        },

        {
          name: "已过期",
          id: 5,
          num: null,
        },
      ],
      //默认订单列表状态状态
      navsindex: 2,
      //当前状态订单
      datalist: [],
      //报名码
      myurl: "",
      show: false,
      //取消报名
      deleteshow: false,
      deleteid: "",
    };
  },
  created() {
    this.getdata(1);
    this.$axios.get("/book/appointmentInfos?status=2").then((res) => {
      this.navlist[1].num = res.data.total;
    });
    this.$axios.get("/book/appointmentInfos?status=6").then((res) => {
      this.navlist[2].num = res.data.total;
    });
  },
  methods: {
    //点击类别
    changenav(index) {
      this.navsindex = index;
    },
    //获取订单列表
    getdata(id) {
      this.navsindex = id;
      this.$axios.get("/book/appointmentInfos?status=" + id).then((res) => {
        this.datalist = res.data.rows;
        if (id == 1) {
          this.navlist[0].num = res.data.total;
        }
        if (id == 2) {
          this.navlist[1].num = res.data.total;
        }
        if (id == 6) {
          this.navlist[2].num = res.data.total;
        }
      });
    },
    //取消列表
    cancel() {
      this.deleteshow = false;
      this.$axios.get("book/cancel?id=" + this.deleteid).then(() => {
        this.getdata(this.navsindex);
      });
    },
    //预览二维码
    myma(url) {
      this.myurl = url;
      this.show = true;
    },
    //点击别处关闭二维码
    onpull($event) {
      if ($event.target.nodeName == "DIV") {
        this.show = false;
        this.myurl = "";
      }
    },
  },
};
</script>
<style>
.el-dialog-centent {
  display: flex;
  align-items: center;
  justify-content: center;
}
.el-dialog {
  margin: 0 0 !important;
  display: flex;
  flex-direction: column;
}
.el-dialog__header {
  display: none;
}
</style>
<style  lang="less" scoped>
.orderCenter {
  .orderCenter-top {
    width: 100%;
    background-color: #a78d60;
    padding: 0 0.2rem;
    box-sizing: border-box;
    .top-item {
      font-size: 0.22rem;
      color: #fff;
      padding-top: 0.3rem;
    }
    .top-navs {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      margin-top: 0.2rem;
      padding-bottom: 0.4rem;
      .navs-item {
        color: rgba(255, 255, 255, 0.8);
        font-size: 0.13rem;
        text-align: center;
        .borderBottom {
          width: 0.35rem;
          height: 0.03rem;
          background-color: transparent;
          margin: 0 auto;
          margin-top: 0.05rem;
        }
        .active {
          background-color: #fff;
        }
      }
      .active {
        color: #fff;
      }
    }
  }
  .orderCenter-bottom {
    background-color: #fff;
    border-top-left-radius: 0.15rem;
    border-top-right-radius: 0.15rem;
    position: relative;
    top: -0.2rem;
    padding: 0.1rem 0.2rem 0 0.2rem;
    box-sizing: border-box;
    .bottom-item {
      margin-bottom: 0.2rem;
      padding: 0.2rem 0 0.1rem 0;
      .bottom-item-left {
        width: 70%;
        .bottom-item-left-title1 {
          color: #142323;
          font-size: 0.18rem;
          margin-bottom: 0.1rem;
        }
        .bottom-item-left-title2 {
          color: #868686;
          font-size: 0.12rem;
          margin-bottom: 0.07rem;
        }
        .bottom-item-left-title3 {
          background-color: rgba(167, 141, 96, 0.2);
          color: #a78d60;
          width: 0.9rem;
          line-height: 0.35rem;
          text-align: center;
          border-radius: 0.05rem;
          margin-top: 0.2rem;
          font-size: 0.15rem;
        }
      }
      .ma {
        width: 0.7rem;
        height: 0.7rem;
        text-align: center;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
    .nobottom {
      width: 100%;
      img {
        width: 100%;
      }
    }
    .active {
      border-top: 1px solid #ccc;
    }
    .prompt {
      font-size: 0.12rem;
      color: #a0a0a0;
      margin-top: 0.3rem;
      line-height: 0.18rem;
      p {
        text-align: justify;
      }
    }
  }
  .pull {
    position: fixed;
    max-width: 768px;
    top: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.3);
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .pull-con {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    .pull-con-title1 {
      font-weight: 500;
      color: #142323;
      letter-spacing: 1px;
      font-size: 0.2rem;
      font-weight: 600;
      text-align: center;
    }
    .pull-con-title2 {
      margin-top: 0.2rem;
      font-size: 0.12rem;
      p {
        margin-bottom: 0.1rem;
        color: #142323;
        letter-spacing: 2px;
      }
    }
    .pull-button {
      width: 100%;
      line-height: 0.31rem;
      // font-size: 0.14rem;
      // text-align: center;
      // border-radius: 0.04rem;
      margin-top: 0.2rem;
      display: flex;
      justify-content: space-between;
      text-align: center;
      div {
        width: 40%;
        border-radius: 0.04rem;
      }
    }
  }
}
</style>